import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, EMPTY, debounceTime, finalize, from, map, startWith, timer } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { SseService } from 'src/app/services/SseService';
import { listasServices } from 'src/app/services/listas.services';
import { TemaService } from 'src/app/services/tema.services';
// MatSnackBar removed — using ToastrService instead
import { MatDialog } from '@angular/material/dialog';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { urlMercado } from 'src/app/utils/mercado-url.util';

@Component({
  selector: 'app-gestion-listas',
  templateUrl: './gestion-listas.component.html',
  styleUrl: './gestion-listas.component.scss'
})
export class GestionListasComponent implements OnInit, OnDestroy {
  public companias: CdkTableVirtualScrollDataSource<companiaLista>;
  public metaapiAccountId: string = '';

  public token: any;
  public mercado: any;
  public selectedValue: string;
  public currentlistcfd: boolean = false;
  public metaapi: boolean = false;
  public invertirEstilos: boolean = true;
  public isLoadingMercado: boolean = false;
  public SubTema: Subscription;
  public selectedIso: any;
  public companiaselected: any;
  public originalData: any;
  public selectedRows: any[] = [];
  selectedRowsMetaapi: boolean | null = null;
  selection = new SelectionModel<any>(true, []);
  selectedTabIndex = 0;
  selectedTabLabel = 'Generar Listas';
  /** idmercado recibido por query param (/listas?id=) para abrir directamente la edición de esa lista. */
  public idMercadoEditar: number | null = null;

  displayedColumns: string[] = ['select', 'n', 'iso',
    'descripcion', 'tipo', 'mercado', 'precioteorico', 'volumen','tradingcurrency', 'broker','contractsize', 'dias'];
  /** Tipo, Mercado y Días (próximos resultados) no aplican a los símbolos de una lista MetaAPI. */
  private readonly COLUMNAS_SIN_METAAPI = ['tipo', 'mercado', 'dias'];
  get columnasVisibles(): string[] {
    return this.metaapi ? this.displayedColumns.filter(col => !this.COLUMNAS_SIN_METAAPI.includes(col)) : this.displayedColumns;
  }
  filaSeleccionada: any;

  sortState: { active: string | null; direction: '' | 'asc' | 'desc' } = { active: null, direction: '' };

  @ViewChild('filterHelpTemplate') filterHelpTemplate!: TemplateRef<void>;
  @ViewChild('panelContainer', { static: true }) panelContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('dividerColumn', { static: true }) dividerColumn?: ElementRef<HTMLDivElement>;

  leftPanelFraction = 0.58;
  rightPanelFraction = 0.42;
  readonly minLeftFraction = 0.35;
  readonly minRightFraction = 0.3;
  private isResizing = false;
  private containerRect?: DOMRect;
  private dividerWidth = 0;

  constructor(private toastr: ToastrService,
    private metaApiService: MetaApiService,
    private _sseservice: SseService, 
    private _cookieService: CookieService, 
    private _httclient: HttpClient, 
    public temaservicio: TemaService,
    private _listasService: listasServices,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.token = this._cookieService.get('auth_token');

    const idParam = this.route.snapshot.queryParamMap.get('id');
    const idMercado = idParam != null ? Number(idParam) : NaN;
    if (!Number.isNaN(idMercado) && idMercado > 0) {
      this.idMercadoEditar = idMercado;
      this.selectedTabIndex = 2;
      this.selectedTabLabel = 'Editar Listas';
    }
    this._sseservice.apiPostNew("listamercados", {}, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        this.mercado = data;
      }
    });
    this.SubTema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.invertirEstilos = data;
      }
    });
    
  }

  get gridTemplateColumns(): string {
    const left = this.leftPanelFraction;
    const right = this.rightPanelFraction;
    return `${left}fr auto ${right}fr`;
  }
  ngOnDestroy(): void {
    this.SubTema.unsubscribe();
    this.selectedRows = [];
    this.selectedRowsMetaapi = null;
    this._listasService.updatelistasCompania(this.selectedRows);
  }

  get mercadoSeleccionado(): any {
    return this.mercado?.find((m: any) => m.idmercado === Number(this.selectedValue));
  }

  /** Abre el activo en /mercados dentro de la lista seleccionada. */
  urlMercadoActivo(element: any): string {
    const mercado = this.mercadoSeleccionado;
    return mercado ? urlMercado(mercado, element.iso ?? '') : '/mercados';
  }

  startResize(event: MouseEvent): void {
    if (!this.panelContainer) {
      return;
    }

    event.preventDefault();
    this.isResizing = true;
    this.containerRect = this.panelContainer.nativeElement.getBoundingClientRect();
    this.dividerWidth = this.dividerColumn?.nativeElement.getBoundingClientRect().width ?? 0;
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.isResizing || !this.containerRect) {
      return;
    }

    const availableWidth = this.containerRect.width - this.dividerWidth;
    if (availableWidth <= 0) {
      return;
    }

    const distanceFromLeft = event.clientX - this.containerRect.left;
    const adjustedLeft = distanceFromLeft - this.dividerWidth * 0.5;
    let nextFraction = adjustedLeft / availableWidth;

    const minLeft = this.minLeftFraction;
    const maxLeft = 1 - this.minRightFraction;
    nextFraction = Math.min(Math.max(nextFraction, minLeft), maxLeft);

    this.leftPanelFraction = parseFloat(nextFraction.toFixed(4));
    this.rightPanelFraction = parseFloat((1 - this.leftPanelFraction).toFixed(4));
  }

  @HostListener('window:mouseup')
  stopResize(): void {
    this.isResizing = false;
    this.containerRect = undefined;
  }

  showFilterHelp(): void {
    if (!this.filterHelpTemplate) {
      return;
    }

    this.dialog.open(this.filterHelpTemplate, {
      width: '420px',
      maxWidth: '90vw'
    });
  }

  buscarCompania() {
    const jsonData = {
      idmercado: this.selectedValue, cfd: this.buscarcfd(this.selectedValue), metaapi: this.buscarmetapi(this.selectedValue)
    };
    this.currentlistcfd = jsonData.cfd;
    this.metaapi = jsonData.metaapi;
    console.log(this.selectedValue);
    this.isLoadingMercado = true;
    this._sseservice.apiPostNew('listadecompaniaspormercadodias', jsonData, this.token)
      .pipe(finalize(() => {
        this.isLoadingMercado = false;
      }))
      .subscribe({
      next: (data: any) => {
        this.originalData = data;
        this.companias = new CdkTableVirtualScrollDataSource(data);
        if(jsonData.metaapi )
        this._sseservice.apiPostNew('metaapi/listadecontractsize', { idmercado: this.selectedValue }, this.token).subscribe({
          next: (contractSizes: any) => {
            const specMap = new Map<number, any>(contractSizes.map((item: any) => [Number(item.idnectum), item]));
            console.log("Spec Map: ", specMap);
            // tbl_compania no tiene descripción, precio ni volumen de los símbolos MetaAPI: se muestran
            // la descripción de la spec y la última vela diaria de MetaTrader (sólo en pantalla).
            this.companias.data.forEach((compania: any) => {
              const spec = specMap.get(Number(compania.idNectum));
              compania.contractsize = spec?.contract_size ?? null;
              if (!spec) return;
              compania.descripcion = compania.descripcion || spec.description;
              if (!compania.precioteorico && spec.ultimo_close != null) {
                compania.precioteorico = Number(spec.ultimo_close);
              }
              if (spec.ultimo_volumen != null) {
                compania.volumen = Number(spec.ultimo_volumen);
              }
            });
//            console.log("Companias con contractsize actualizado: ", this.companias);
            // Procesar de forma secuencial las companias sin contractsize (una a la vez)
            const companiasSinSpec = this.companias.data.filter((c: any) => !c.contractsize);
            if (companiasSinSpec.length > 0) {
              this.metaapiAccountId = localStorage.getItem('metaapi_account_id') ?? '';
              if (this.metaapiAccountId === '') {
                this.toastr.error('No se encontró la cuenta de MetaAPI. Por favor, configure su cuenta para obtener las especificaciones de los símbolos.');
              } else {
                from(companiasSinSpec).pipe(
                  concatMap((compania: any) =>
                    timer(100).pipe(
                      concatMap(() =>
                        this.metaApiService.getSymbolSpecification(this.metaapiAccountId, compania.iso).pipe(
                          concatMap((spec: any) => {
                            if (!spec) return EMPTY;
                            const licencia = this._cookieService.get('auth_token');
                            let contractSize = spec.contractSize ?? null;
                            compania.contractsize = contractSize;
                            compania.descripcion = compania.descripcion || spec.description;
                            return this._sseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: 'METAAPI' }, licencia);
                          }),
                          catchError(() => EMPTY)
                        )
                      )
                    )
                  )
                ).subscribe();
              }
            }
            this.companias = new CdkTableVirtualScrollDataSource(this.companias.data);
          }
        });

        
      },
      error: () => {
        this.companias = new CdkTableVirtualScrollDataSource<companiaLista>([]);
      }
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(filterValue);

    // Dividir el valor del filtro en criterios separados
    const filters = filterValue.split(' ');

    // Definir los criterios de filtro
    let mercadoFilter = '';
    let tipoFilter = '';
    let descripcionFilter = '';
    let companiaFilter = '';
    let volumenFilter: { operator: string, value: number } | null = null;
    let cotizacionFilter: { operator: string, value: number } | null = null;

    filters.forEach(filter => {
      if (filter.startsWith('iso:')) {
        companiaFilter = filter.substring(4).trim();
      }if (filter.startsWith('compania:')) {
        companiaFilter = filter.substring(4).trim();
      }
       else if (filter.startsWith('mercado:')) {
        mercadoFilter = filter.substring(8).trim();
      } else if (filter.startsWith('tipo:')) {
        tipoFilter = filter.substring(5).trim();
      } else if (filter.startsWith('descripcion:')) {
        descripcionFilter = filter.substring(12).trim();
      } else if (filter.startsWith('compañia:')) {
        companiaFilter = filter.substring(9).trim();
      } else if (filter.startsWith('volumen>')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('volumen<')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '<', value: value };
        }
      }else if (filter.startsWith('cotizacion>')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('cotizacion<')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '<', value: value };
        }
      }else{
        companiaFilter = filter.trim();
        descripcionFilter = filter.trim();
      }
    });
    console.log("esto es iso:", companiaFilter);
    console.log("esto es mercadoFilter:", mercadoFilter);
    console.log("esto es tipoFilter:", tipoFilter);
    console.log("esto es volumenFilter:", volumenFilter);
    console.log("esto es cotizacionFilter:", cotizacionFilter);
    console.log("esto es descripcionFilter:", descripcionFilter);

    this.companias = new CdkTableVirtualScrollDataSource(this.originalData.filter(
      (item: companiaLista) => {
        const mercadoMatch = mercadoFilter === '' || (item.mercado && item.mercado.toLowerCase().includes(mercadoFilter));
        const tipoMatch = tipoFilter === '' || (item.tipo && item.tipo.toLowerCase().includes(tipoFilter))
        const descripcionMatch = descripcionFilter === '' || (item.descripcion && item.descripcion.toLowerCase().includes(descripcionFilter))
        const companiaMatch = companiaFilter === '' || (item.iso && item.iso.toLowerCase().includes(companiaFilter))
        console.log("descripcionMatch:", descripcionMatch);
        console.log("companiaMatch:", companiaMatch);

        let volumenMatch = true;
        if (volumenFilter) {
          switch (volumenFilter.operator) {
            case '>':
              volumenMatch = item.volumen > volumenFilter.value;
              break;
            case '<':
              volumenMatch = item.volumen < volumenFilter.value;
              break;
          }
        }
        let cotizacionMatch = true;
        if (cotizacionFilter) {
          switch (cotizacionFilter.operator) {
            case '>':
              cotizacionMatch = item.precioteorico > cotizacionFilter.value;
              break;
            case '<':
              cotizacionMatch = item.precioteorico < cotizacionFilter.value;
              break;
          }
        }
        return mercadoMatch && tipoMatch && ( descripcionMatch || companiaMatch ) && volumenMatch && cotizacionMatch;
        // return mercadoMatch;
      }
    ));
    this.applySortIfNeeded();
  }
  enviarDatos() {
    // agregar if si el tab Generar Listas esta seleccionado
    console.log("SELECCIONADAS: ", this.selectedTabIndex);
    if (this.selectedTabIndex === 0) 
    this._listasService.updatelistasCompania(this.selectedRows);
    else if (this.selectedTabIndex === 2){
      console.log(this.selectedRows);
      this._listasService.addlistasEditarCompania(this.selectedRows);
      // Limpiar la selección tras enviarla: evita reenviar las mismas filas (duplicados)
      // y da feedback visual de que se añadieron.
      this.selectedRows = [];
      this.selectedRowsMetaapi = null;
    }
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;

  }
/*   selectAll(event: any): void {
    // Implementa la lógica para seleccionar/desmarcar todas las filas
    if (event.checked) {
      // Seleccionar todas las filas
      this.filaSeleccionada = this.companias.data;
    } else {
      // Deseleccionar todas las filas
      this.filaSeleccionada = [];
    }
  } */

  toggleSelection(row: any): void {

    console.log("ESTO LLEVO ACUMULADO: ", this.selectedRows);
    const index = this.selectedRows.indexOf(row);
    if (index === -1) {
      if (this.selectedRows.length > 0 && this.selectedRowsMetaapi !== null && this.selectedRowsMetaapi !== this.metaapi) {
        this.toastr.error('No se pueden mezclar activos MetaAPI con activos no MetaAPI en una misma lista.', 'Error');
        return;
      }
      this.selectedRows.push(row);
      if (this.selectedRowsMetaapi === null) {
        this.selectedRowsMetaapi = this.metaapi;
      }
    } else {
      this.selectedRows.splice(index, 1);
      if (this.selectedRows.length === 0) {
        this.selectedRowsMetaapi = null;
      }
    }
  }

  isAllSelected() {
/*     console.log("Se agregaron todos: ")
    const numSelected = this.selection.selected.length;
    const numRows = this.companias.data.length;
    return numSelected === numRows; */
    const numSelected = this.selectedRows.length;
    const numRows = this.companias.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selectedRows = [];
      this.selectedRowsMetaapi = null;
    } else {
      if (this.selectedRows.length > 0 && this.selectedRowsMetaapi !== null && this.selectedRowsMetaapi !== this.metaapi) {
        this.toastr.error('No se pueden mezclar activos MetaAPI con activos no MetaAPI en una misma lista.', 'Error');
        return;
      }
      this.selectedRows = [...this.companias.data];
      this.selectedRowsMetaapi = this.metaapi;
    }
    console.log("AHORA SELECTEDROW TIENE TODS: ", this.selectedRows);
  }

  isSelected(row: any): boolean {
    return this.selectedRows.indexOf(row) !== -1;
  }
  buscarcfd(selectedValue: string) {
    console.log(this.mercado);
    //filtrar this.idmercado que es una lista y buscar por idmercado = number(selectedValue) si es asi retornar true si sectype = 'CFD'
    return this.mercado.find((mercado: any) => mercado.idmercado === Number(selectedValue) && mercado.sectype === 'CFD')? true : false;

        }
  buscarmetapi(selectedValue: string) {
    console.log(this.mercado);
    //filtrar this.idmercado que es una lista y buscar por idmercado = number(selectedValue) si es asi retornar true si metaapi = 'true'
     let mercadof = this.mercado.find((mercado: any) => mercado.idmercado === Number(selectedValue));
     console.log("esto es mercadof: ", mercadof);
    return mercadof.metaapi;

        }
    copyToExcel() {
        if (!this.companias || !this.companias.data || this.companias.data.length === 0) {
            return;
        }

        // Create headers
        const headers = this.columnasVisibles
            .filter(col => col !== 'select')
            .join('\t');

        // Create rows
        const rows = this.companias.data.map((item: companiaLista) => {
            return this.columnasVisibles
                .filter(col => col !== 'select')
                .map(col => {
                    // Format numbers if needed
                    if (col === 'precioteorico' || col === 'volumen') {
                        const value = item[col as keyof companiaLista];
                        return typeof value === 'number' ? value.toFixed(2) : '';
                    }
                    // Add CFD label if needed
                    if (col === 'iso') {
                        return `${item.iso} ${item.secType === 'CFD' ? 'CFD' : ''}`;
                    }
                    const value = item[col as keyof companiaLista];
                    return value !== undefined ? String(value) : '';
                })
                .join('\t');
        }).join('\n');

        // Combine headers and rows
        const csvContent = `${headers}\n${rows}`;

        // Create a temporary textarea to copy the content
        const textarea = document.createElement('textarea');
        textarea.value = csvContent;
        document.body.appendChild(textarea);
        textarea.select();
        
        try {
          document.execCommand('copy');
          this.toastr.success('Datos copiados al portapapeles', 'OK', { timeOut: 3000, positionClass: 'toast-top-center' });
        } catch (err) {
          this.toastr.error('Error al copiar los datos', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
        } finally {
            document.body.removeChild(textarea);
        }
    }

  onSaveEdit(evt: { id: number; name: string; items: any[] }) {
    console.log('Editar lista -> guardar', evt);
  }
  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    this.selectedTabLabel = event.tab.textLabel ?? '';
    // aquí puedes ejecutar lógica según la pestaña
  }

  sortBy(columnId: string): void {
    if (this.sortState.active !== columnId) {
      this.sortState = { active: columnId, direction: 'asc' };
    } else {
      this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : this.sortState.direction === 'desc' ? 'asc' : '';
      if (!this.sortState.direction) this.sortState.active = null;
    }
    this.applySortIfNeeded();
  }

  private applySortIfNeeded(): void {
    if (!this.companias) return;

    const data = (this.companias.data ?? []) as any[];
    if (!this.sortState.active || !this.sortState.direction) {
      // Restablecer orden por índice (n) si existe
      const reset = [...data].sort((a, b) => (a?.n ?? 0) - (b?.n ?? 0));
      this.companias = new CdkTableVirtualScrollDataSource(reset);
      return;
    }

    const col = this.sortState.active;
    const dir = this.sortState.direction === 'asc' ? 1 : -1;

    const numberCols = new Set(['n', 'precioteorico', 'volumen', 'dias']);
    const isNumber = numberCols.has(col);

    const sorted = [...data].sort((a, b) => {
      // Special handling for 'broker' column
      if (col === 'broker') {
        // Calculate broker score: 0 = none, 1 = one ID, 2 = both IDs
        const scoreA = (a?.conid ? 1 : 0) + (a?.conidcfd ? 1 : 0);
        const scoreB = (b?.conid ? 1 : 0) + (b?.conidcfd ? 1 : 0);
        
        if (scoreA === scoreB) return 0;
        return (scoreA - scoreB) * dir;
      }

      const vaRaw = a?.[col];
      const vbRaw = b?.[col];

      const va = isNumber ? Number(vaRaw) : (vaRaw ?? '').toString().toLowerCase();
      const vb = isNumber ? Number(vbRaw) : (vbRaw ?? '').toString().toLowerCase();

      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;

      if (va < vb) return -1 * dir;
      if (va > vb) return  1 * dir;
      return 0;
    });

    this.companias = new CdkTableVirtualScrollDataSource(sorted);
  }
}


